import { useDispatch } from "react-redux";
import { useToast } from "@chakra-ui/react";
import { useQueryClient } from "react-query";
import { useTranslation } from "react-i18next";
import { showErrorToast, showSuccessToast } from "../../../../../../utils";
import { hideAppSpinner } from "../../../../../../context/Store/slices/appSpinnerSlice";
import * as React from "react";
import { ImportData } from "../../../../../../components/ImportData";

function ImportItemsButton({ itemsType, importItemsHook, itemsKeys, questionnaireId, tooltip, downloadTemplate }) {
  const dispatch = useDispatch();
  const toast = useToast();
  const queryClient = useQueryClient();
  const { t } = useTranslation("translation");
  const importBtnId = `import-${itemsType}-items-btn`;

  const queryConfig = {
    onSuccess: () => {
      showSuccessToast(toast, t("organizationQuestionnaire.page.imported"));
      queryClient.invalidateQueries(itemsKeys.items());
    },
    onError: err => {
      let errorMessage = "";
      if (err.response?.status === 500 && err.response?.data?.message?.toLowerCase().includes("index")) {
        errorMessage = t("validationErrors.invalidExcelFile");
      } else if (err.response?.status === 409) {
        errorMessage = t("validationErrors.existingData");
      } else if (err.response?.data?.errorCode === "file-argument-not-valid") {
        errorMessage = err.response?.data?.parameters?.message ?? err.message;
      } else if (err.response?.data?.message) {
        errorMessage = err.response?.data?.message ?? err.message;
      } else {
        errorMessage = err.message;
      }
      showErrorToast(toast, errorMessage);
    },
    onSettled: () => dispatch(hideAppSpinner())
  };

  return (
    <ImportData
      importDataBtnId={importBtnId}
      importDataHook={importItemsHook}
      importDataConfig={queryConfig}
      importDataParams={{ questionnaireId }}
      downloadTemplateHook={downloadTemplate}
      downloadTemplateParams={{ questionnaireId }}
      tooltip={tooltip}
    />
  );
}

export default ImportItemsButton;